import colors from './colors';

export default {
  backgroundColor: 'transparent',
  borderColor: colors.primaryColor,
  borderColorInvalid: colors.errorColor,
  borderRadius: '0px',
  borderWidth: '1px',
  checkboxSize: '1.5rem',
  color: colors.primaryColor,
  fieldHeight: '3rem',
  fontSize: '1rem',
  labelTextColor: colors.primaryBackgroundColor,
  labelTextFontSize: '0.9rem',
  labelTextLineHeight: 'inherit',
  padding: '1rem',
  placeholderColor: colors.primaryBackgroundColor,
  radioSize: '1.5rem',
};
